module.exports = __webpack_public_path__ + "img/octavio.98a72edc.png";